var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMoreGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_126_24114_00000142874772438457498560000014968628477770450840_);}\r\n\t.st2{fill:#0E9384;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand_more"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 6.7,
    y: 8.8,
    width: 10.6,
    height: 6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 6.7,
    y: 8.8,
    width: 10.6,
    height: 6,
    id: "mask0_126_24114_00000142874772438457498560000014968628477770450840_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box_00000001622680171900179950000011794710267847507074_",
    y: 0.2,
    className: "st0",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_more_2",
    className: "st2",
    d: "M12,14.9L6.7,9.5l0.7-0.7l4.6,4.6l4.6-4.6l0.7,0.7L12,14.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMoreGreenIcon);
export default __webpack_public_path__ + "static/media/expand-more-green-icon.942b279a2bb43538b7f4dcac208482cf.svg";
export { ForwardRef as ReactComponent };